/*
*
* PRODUIT JS
*
*/

function resetBtnFavori(favori) {

  var element = $('#produit-favori');
  var title = favori ? Lang._i('produit.annuler_suivi') : Lang._i('produit.suivre');
  var icon = favori ? 'star' : 'star_border';
  var oldClass = favori ? 'ajouter-produit-favori' : 'retirer-produit-favori';
  var newClass = favori ? 'retirer-produit-favori' : 'ajouter-produit-favori';

  element.removeClass(oldClass).addClass(newClass).contents().first().replaceWith(title);
  element.find('i').text(icon);
}

$(document).ready(function() {

  $('body').on('click','#magasin_modal_remote',function (e){
    e.preventDefault();
    $("#modal-contact-magasin").modal('show').find('.modal-body').load($(this).attr('href'));
  })



  // INIT MAP
  if ($('#magasin-map').length > 0) {
    loadMapMagasin();
  }

  var $zoom = undefined;

  function initZoom() {
    if($(window).width() > 992 && $zoom == undefined) {
      //console.log('a')
      $zoom = $('.zoom').magnify();
    }
    else {
      //console.log('b')
      if($zoom != undefined) {
        //console.log('c', $zoom)
        $zoom.destroy();
        $zoom = undefined;
      }
    }
  }

  if ($('.zoom').length > 0) {
    // $('.zoom').magnify();
    initZoom();
    $(window).on('resize', function() {
      initZoom();
    })
  }

  initReveal('.selection-troc-wrapper .section-heading', {
    delay: 200,
    useDelay: 'onload',
    interval: 150,
    reset: false,
    distance: '10px',
    origin: 'bottom',
    easing: 'ease'
  });

  function loadMapMagasin() {

    var markerHtml = $('.map-card');
    var mymap = L.map('magasin-map').setView([markerHtml.data('lat'), markerHtml.data('lng')], 13);

    //skin de la map
    L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      minZoom: 1,
      maxZoom: 19,
      detectRetina: true
    }).addTo(mymap);


    var trocIcon = L.icon({
      iconUrl: '/images/locator-troc.svg',
      iconSize: [48, 48]
    });

    L.marker([markerHtml.data('lat'), markerHtml.data('lng')], {
        icon: trocIcon
      })
      //.bindPopup( markerHtml.html() )//ajout du marker magasin (désactivé, mais marche)
      .addTo(mymap);

  }

  // INIT DIFFERENT SLIDER : MOBILE/TABLETTE/DEKSTOP

  function initSliderDesktop() {
    $('.product-slider-js').owlCarousel({
      items: 1,
      nav: false,
      dots: false,
      touchDrag  : false,
      mouseDrag  : false,
      lazyLoad:true
    });
  }

  function initSliderMobile() {
    $('.product-slider-js').owlCarousel({
      items:1,
      // autoWidth:true,
      stagePadding: 0,
      center: true,
      loop: true,
      nav: false,
      dots: false,
      lazyLoad:true
    });
  }

  function initSliderTablette() {
    $('.product-slider-js').owlCarousel({
      items:1,
      loop: false,
      stagePadding: 0,
      nav: false,
      dots: false,
      lazyLoad:true
    });
  }

  //INIT SLIDER FROM WINDOW WIDTH

  if ( $(window).width() < 768 ) {
    initSliderMobile();
  } else if ( $(window).width() < 992 ){
    initSliderTablette();
  } else {
    initSliderDesktop();
  }

  $(window).resize(function() {
    if ( $(window).width() < 768 ) {
      var $owl = $('.product-slider-js');
      $owl.trigger('destroy.owl.carousel');
      initSliderMobile();
    } else if ( $(window).width() < 992 ){
      var $owl = $('.product-slider-js');
      $owl.trigger('destroy.owl.carousel');
      initSliderTablette();
    } else {
      var $owl = $('.product-slider-js');
      $owl.trigger('destroy.owl.carousel');
      initSliderDesktop();
    }
  });

  // SWITCH IMAGE
  $(document).on('click', '.slide-thumb-js', function() {
    let classes = ['o-04', 'active-item'];
    $('.slide-thumb-js').css({
      'pointer-events' : ''
    })
    $(this).css({
      'pointer-events' : 'none'
    })
    let $this = $(this);
    $.each(classes, function(i, classe) {
      $('.slide-thumb-js').removeClass(classe)
      $this.addClass(classe)
    })
    
  })

  function Navigation_slider(direction = '', intSlide = 0, elementTrigger) {

    let classes = ['o-04', 'active-item'];
    let thumbs = $('.slide-thumb-js');
    let thumbCount = thumbs.length;
    let thumbActive = direction ? $('.slide-thumb-js.active-item'): elementTrigger;
    let thumbActiveSlideIndex = parseInt( thumbActive.attr('data-slide') );
    intSlide = thumbActiveSlideIndex;

    if(direction === 'right' && thumbActiveSlideIndex < thumbCount - 1 && direction != false) {
      intSlide = intSlide + 1;
    }
    if(direction === 'left' && thumbActiveSlideIndex > 0 && direction != false) {
      intSlide = intSlide - 1;
    }

    if(intSlide === thumbCount - 1) {
      $('.js-arrows[data-direction="right"]').addClass('inactive');
    }
    else {
      $('.js-arrows[data-direction="right"]').removeClass('inactive');
    }

    if(intSlide === 0) {
      $('.js-arrows[data-direction="left"]').addClass('inactive');
    }
    else {
      $('.js-arrows[data-direction="left"]').removeClass('inactive');
    }


    let thumbNewActive = $('.slide-thumb-js[data-slide="'+ intSlide +'"]');
    $.each(classes, function(i, classe) {
      $('.slide-thumb-js').removeClass(classe)
      thumbNewActive.addClass(classe)
    })
    $('.product-slider-js').trigger('to.owl.carousel', intSlide);

  }

  $(document).on('click', '.js-arrows', function(e) {
    e.preventDefault();
    let $data_direction = $(this).attr('data-direction');
    Navigation_slider($data_direction);

  })

  // FULLSCREEN IMAGE
  $(document).on('click', '.product-slider-js .owl-item', function() {
    $('.imagepreview').attr('src', $(this).find('img').attr('data-magnify-src'));
    $('#modal-product').modal('show');
  });

  $("#modal-product").on('show.bs.modal', function(e) {
    var $image = $(this).find('.imagepreview');

    var img = new Image()
    img.src = $image.attr('src');

    var $width = $image.width();
    var $height = $image.height();

    // $('.modal-zoom .modal-dialog').css({width: img.width + 'px', height: img.height + 'px'})

  })

  //IF 1 THUMBNAILS = NO SLIDER

  var numberOfThumb = $('.product-thumbnails .slide-thumb-js').length;
  if (numberOfThumb == 1) {
    $('.product-thumbnails').addClass('no-thumbnails');
    $('.product-pictures').addClass('col-lg-12');
  } else {
    $('.slide-thumb-js').on('click', function(){
      var itemSlide = $(this).data('slide');
      Navigation_slider(false, parseInt(itemSlide), $(this))
      // $('.product-slider-js').trigger('to.owl.carousel', itemSlide);
    });
  }

  $('.retirer-produit-favori, .ajouter-produit-favori').on('click', function(e) {

    e.preventDefault();

    var produitId = $(this).attr('data-produit-id');
    var favori = $(this).hasClass('ajouter-produit-favori');

    if (favori) {

      var url = route('ajax.alerte_produit.ajouter', {'id': produitId}).toString();
    }
    else {

      var url = route('ajax.alerte_produit.retirer', {'id': produitId}).toString();
    }

    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json'
    })
    .done(function(data, textStatus, jqXHR) {

      if (jqXHR.status == 200 || jqXHR.status == 304) {

        resetBtnFavori(favori);
      }
      else {

        $('#ajax-error-modal').modal('toggle');
      }
    })
    .fail(function(jqXHR, textStatus, errorThrown) {

      if (jqXHR.status == 401) {

        $('#alerte-produit-modal').modal('toggle');
      }
      else {

        $('#ajax-error-modal').modal('toggle');
      }
    });
  });
});
